// Adds `.header-scrolled` to the fixed header once the page is scrolled
// past a small threshold, matching the source behavior.
export default function initHeaderScroll() {
  const header = document.getElementById("header")
  if (!header) return

  const onScroll = () => {
    if (window.scrollY > 40) {
      header.classList.add("header-scrolled")
    } else {
      header.classList.remove("header-scrolled")
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true })
  onScroll()
}
